<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('photographyDetails.breadcrumb_1')}}</router-link></li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active mx-3 almarai-bold">
          <router-link to="/myrequests">
            {{$t('photographyDetails.breadcrumb_2')}}
          </router-link>
        </li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active mx-3 almarai-bold" aria-current="page">
          {{$t('photographyDetails.breadcrumb_3')}}
        </li>
      </ol>
    </nav>
  </div>
  <div class="container">
    <div class="row">
      <div class="col">

        <div v-if="isLoading" class="text-center">
          <mainloader /> 
        </div>

        <!-- <div class="row">
          <div class="col">
            <div class="row p-3">
              <div class="col">
                <h6 class="almarai-bold">{{row.title}}</h6>
                <div class="fonttext-14 gray-color almarai-regular">{{row.description}}</div>
                <div class="almarai-bold pt-3">{{$t('photographyDetails.breadcrumb_3')}}</div>
                <div class="row">
                  <div class="col border-dash px-3">
                    <div class="row" v-if="row.doneTime">
                      <div class="col position-R">
                        <div>{{row.doneTime}}</div>
                        <i  v-if="currentStage == 'done'" class="fa-solid fa-circle-dot orange-color button-steps"></i>
                        <i  v-else class="fa-solid fa-circle-dot gray-B4 button-steps"></i>
                        <div>{{status.done}}</div>
                      </div>
                    </div>

                    <div class="row" v-if="row.arriveTime">
                      <div class="col position-R">
                        <div>{{row.arriveTime}}</div>
                        <i  v-if="currentStage == 'arrive'" class="fa-solid fa-circle-dot orange-color button-steps"></i>
                        <i  v-else class="fa-solid fa-circle-dot gray-B4 button-steps"></i>
                        <div>{{status.arrived}}</div>
                      </div>
                    </div>
                    <div class="row pt-3" v-if="row.assignTime" >
                      <div class="col position-R">
                        <div>{{moment(row.assignTime).format('LT')}}</div>
                        <i  v-if="currentStage == 'assign'" class="fa-solid fa-circle-dot orange-color button-steps"></i>
                        <i  v-else class="fa-solid fa-circle-dot gray-B4  button-steps"></i>
                        <div class="fonttext-14 almarai-regular">{{status.assigned}}</div>

                        <div class="row">
                          <div class="col-auto text-center">
                            <i class="bi bi-person font-36 pe-2"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pt-3">
                      <div class="col position-R">
                        <div>{{moment(row.createdAt).format('LT')}}</div>
                        <div class="fonttext-14 almarai-regular"></div>
                        <div class="fonttext-14 almarai-regular">{{status[row.status]}}</div>
                          <i v-if="currentStage == 'created'" class="fa-solid fa-circle-dot orange-color button-steps"></i>
                        <i v-else class="fa-solid fa-circle-dot gray-B4  button-steps"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-5 justify-content-center">
                  <div class="col-11 col-md-5 text-center" v-if="row.paymentGate == 'online'">
                    <div @click.prevent="paymentFN" class="form-control padding-style almarai-bold buttonStyle">{{$t('maintenanceDetails.title_5')}} <span class="mx-1">{{row.price}} {{$t('maintenanceDetails.title_7')}}</span> </div>
                  </div>
                  <div class="col-11 col-md-5 text-center mt-3" v-if="!row.arriveTime" @click="poupCanenllOrder"> 
                    <div class="form-control btn-black">{{$t('photographyDetails.Cancel_Order_Button')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div v-else class="row">
          <div class="col" v-if="step == 1">
            <div class="row p-3">
              <div class="col-12 col-lg-6 d-block d-lg-none">
                <h6>{{$t('maintenances.orderStatus')}}</h6>
                <div class="row">
                  <div class="col">
                    <div class="card br-radius-16 position-R">
                      <img src="/assets/images/icons/Artboard.png" class="slogan" alt="">
                      <div class="card-body text-center">
                        <div class="row"  v-if="row.status == 'new'">
                          <div class="col-12">
                            <div>
                              <img src="/assets/images/icons/search-Icon.png" class="search-Icon" alt="">
                            </div>
                            <div class="technician-style">
                              <span>{{$t('maintenances.technician')}}</span>
                              <span class="mx-1">🔍</span>
                            </div>
                            <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                            <div class="confirmed">{{$t('maintenances.area')}}</div>
                          </div>
                        </div>

                        <div class="row" v-if="row.Provider">
                          <div class="col-12">
                            <div class="row" v-if="row.status == 'assigned'">
                              <div class="col">
                                <div>
                                  <img src="/assets/images/icons/moto.png" class="search-Icon" alt="">
                                </div>
                                <div class="technician-style">
                                  <!-- <span>{{$t('maintenances.technician')}}</span> -->
                                  <span>{{$t('maintenanceDetails.theTechnician')}}</span>
                                  <span class="mx-1">🔧</span>
                                </div>
                                <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                                <div class="confirmed">{{$t('maintenances.area')}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-if="row.status == 'done'">
                          <div class="col">
                            <div>
                              <img src="/assets/images/icons/trueIcon.png" class="search-Icon" alt="">
                            </div>
                            <div class="technician-style">
                              <span>{{$t('maintenanceDetails.successfullyResolved')}}</span>
                            </div>
                            <!-- <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                            <div class="confirmed">{{$t('maintenances.area')}}</div> -->
                          </div>
                        </div>

                        <div class="row" v-if="['client_canceled','provier_canceled'].indexOf(row.status) != -1">
                          <div class="text-center">
                            <img src="/assets/images/icons/Erorr_img.png" class="max-50" alt="">
                          </div>
                          <div class="col">
                            {{status[row.status]}}
                          </div>
                        </div>

                        <div class="row" v-if="['deposit_issue','hold','payment_issue','scheduled','under_review','waiting_deposit','waiting_payment'].indexOf(row.status) != -1">
                          <div class="text-center">
                            <img src="/assets/images/icons/wating_img.png" class="max-50" alt="">
                          </div>
                          <div class="col">
                            {{status[row.status]}}
                          </div>
                        </div>

                        <div class="row pt-3">
                          <div class="col-12">
                            <span :class="(['new', 'assigned', 'arrived', 'done', 'hold', 'scheduled'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['assigned', 'arrived', 'done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['arrived', 'done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-3 justify-content-center">
                  <div class="col-11 content-end text-center" v-if="row.deposit !=0 && row.status == 'waiting_deposit' || row.status == 'deposit_issue'">
                    <div @click.prevent="poupPaymentOrder" class="form-control padding-style almarai-bold buttonStyle">{{$t('maintenanceDetails.title_5')}} {{row.deposit}} {{$t('maintenanceDetails.title_7')}} </div>
                  </div>
                  <div class="col-11 text-center" v-if="row.finalPayment != 0 && row.status == 'payment_issue' || row.status == 'waiting_payment'">
                    <div @click.prevent="next" class="form-control padding-style almarai-bold buttonStyle">{{$t('maintenanceDetails.title_5')}} {{row.finalPayment}} {{$t('maintenanceDetails.title_7')}} </div>
                  </div>
                  <div class="col-11 col-md-5 text-center mt-3" v-if="row.status !='done' && row.status !='client_canceled' && row.status !='provier_canceled'" @click="poupCanenllOrder"> 
                    <button class="form-control black-button almarai-bold padding-style">{{$t('maintenanceDetails.title_6')}}</button>
                  </div>
                  <!-- <div class="col-11 text-center" v-if="row.status =='done' && !row.rate" @click.prevent="ratingPoup"> 
                    <div class="form-control black-button almarai-bold padding-style">
                      {{$t('maintenanceDetails.evaluateExperience')}}
                    </div>
                  </div> -->
                </div>
              </div>

              <div class="col-12 col-lg-6">
                <div class="row" v-if="row.Provider && row.status !='done'">
                  <div class="col-12">
                    <div class="row">
                      <div class="col">
                        <span class="almarai-bold">{{$t('maintenances.technicalInformation')}}</span>
                      </div>
                      <div class="col-auto provider_Line" @click.prevent="requestChangeProvider" v-if="row.status !='done'">
                        <span class="changeProvider">{{$t('maintenanceDetails.request_ChangeProvider')}}</span>
                      </div>
                    </div>
                    <div class="card bg-maintenance">
                      <div class="card-body">
                        <div class="row">
                          <div class="col">
                            
                          </div>
                          <!-- <div class="col-auto content-center ps-0">
                            <a :href="'https://wa.me/+966'+row.Provider.mobile" target="_blank">
                              <img src="/assets/images/icons/WhatsApp-1.png" class="max-24" alt="">
                            </a>
                          </div>
                          <div class="col-auto content-center ps-0">
                            <a :href="'tel:+966'+row.Provider.mobile" target="_blank">
                              <img src="/assets/images/icons/mobile-calling.png" class="max-24" alt="">
                            </a>
                          </div> -->
                          <div  class="col-auto content-center mouse-hand" @click.prevent="toggleDiv">
                            <img src="/assets/images/icons/message.png" class="max-24" alt="">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col-12">
                    <h6>{{$t('maintenances.orderDetails')}}</h6>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="card bg-maintenance">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-12 mb-3">
                            <strong>{{$t('maintenances.order_number')}}:</strong> # {{ row.id }}
                            <!-- <div class="fontGray-73">
                              {{row.User.name}}
                            </div> -->
                            <div class="fontGray-73">
                              <span>{{$t('maintenances.phoneNumber')}}</span> : #
                              <span>{{row.mobile}}</span>
                            </div>
                          </div>
                        </div>
                        <hr class="m-0">
                        <div class="row pt-2">
                          <div class="col-12 mb-3">
                            <strong> {{$t('maintenances.service_name')}} </strong>
                            <div class="row">
                              <div class="col fontGray-73">
                                <div> {{(row.MaintenanceIssue)? row.MaintenanceIssue.name : 'غير معروف'}} </div>
                                <div> {{ row.title }} </div>
                                <div> {{ row.description }} </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col-12">
                    <h6>{{$t('maintenances.serviceCost')}}</h6>
                    <div class="row">
                      <div class="col-12">
                        <div class="card bg-maintenance">
                          <div class="card-body fontGray-73">
                            <div class="row">
                              <div class="col">
                                {{$t('maintenances.totalAmount')}}
                              </div>
                              <div class="col-auto">
                                <span class="mx-1 fontGray-73">{{row.price}}</span>
                                <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                

                <!-- <div class="row pt-3">
                  <div v-if="row.image" class="col-12 mb-3">
                    <strong>{{$t('maintenances.image')}}:</strong> <br>
                    <img :src="MEDIA_URL+row.image" style="max-width: 100%;" alt="">
                  </div>
                </div> -->

                <!-- <hr class="line-color"> -->
                <!-- <div class="almarai-bold pt-3">{{$t('maintenanceDetails.breadcrumb_3')}}</div>
                <div class="row pt-3">
                  <div class="col border-dash px-3">
                    <div class="row">
                      <div class="col position-R">
                        <div class="gray-color">{{moment(row.createdAt).format('h:mm a')}}</div>
                        <div class="fonttext-14 almarai-regular">{{$t('maintenanceDetails.title_4')}}</div>
                          <i v-if="currentStage == 'created'" class="fa-solid fa-circle-dot currentStatus button-steps"></i>
                        <i v-else class="fa-solid fa-circle-dot gray-B4  button-steps"></i>
                      </div>
                    </div>

                    <div class="row pt-4" v-if="row.assignTime" >
                      <div class="col position-R">
                        <div class="gray-color">{{moment(row.assignTime).format('h:mm a')}}</div>
                        <i  v-if="currentStage == 'assign'" class="fa-solid fa-circle-dot currentStatus button-steps"></i>
                        <i  v-else class="fa-solid fa-circle-dot gray-B4  button-steps"></i>
                        <div class="fonttext-14 almarai-regular pb-2">{{status.assigned}}</div>

                        <div class="row" v-if="row.Provider">
                          <div class="col-3 col-md-1 text-center ps-0" v-if="row.Provider.avatar">
                            <div class="provider-img">
                              <img :src="MEDIA_URL+row.Provider.avatar" class="w-100" alt="">
                            </div>
                          </div>
                          <div v-else class="col-auto text-center ps-0">
                            <i  class="bi bi-person font-36 pe-2"></i>
                          </div>
                          <div class="col-6">
                            <div>{{row.Provider.name}}</div>
                            <div>{{row.Provider.mobile}}</div>
                            <div class="text-style">{{$t('maintenanceDetails.technician')}}</div>
                            <div id="providerRate"></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pt-4" v-if="row.arriveTime">
                      <div class="col position-R">
                        <div class="gray-color">{{moment(row.arriveTime).format('h:mm a')}}</div>
                        <i  v-if="currentStage == 'arrive'" class="fa-solid fa-circle-dot currentStatus button-steps"></i>
                        <i  v-else class="fa-solid fa-circle-dot gray-B4 button-steps"></i>
                        <div>{{status.arrived}}</div>
                      </div>
                    </div>

                    <div class="row pt-4" v-if="row.doneTime">
                      <div class="col position-R">
                        <i  v-if="currentStage == 'done'" class="fa-solid fa-circle-dot currentStatus button-steps"></i>
                        <i  v-else class="fa-solid fa-circle-dot gray-B4 button-steps"></i>
                        <span class="gray-color">{{moment(row.doneTime).format('h:mm a')}}</span>
                        <div>{{status.done}}</div>
                      </div>
                    </div>                    
                  </div>
                </div> -->
                <!-- <div v-if="billUrl" class="row justify-content-center pt-2">
                  <div class="col-12">
                    <a :href="BASE_URL+billUrl" target="_blank" type="application/pdf">
                      <div class="button-bill">
                        <span class="mx-2">{{$t('invoiceDetails')}}</span>
                      </div>
                    </a>
                  </div>
                </div> -->

                <div class="row pt-2" v-if="row.doneNotice">
                  <div class="col">
                    <h6 class="small-Font">{{$t('maintenanceDetails.providerNotes')}}</h6>
                    <div class="card bg-maintenance">
                      <div class="card-boby p-2">
                        <div class="almarai-bold gray-color-76">{{row.doneNotice}}</div>
                      </div>
                    </div>
                  </div>
                </div>


                <!-- <div class="row pt-2 justify-content-center" v-if="row.imageBefore || row.imageAfter">
                  <div class="col-12">
                    <h6 class="almarai-bold pb-1">{{$t('maintenanceDetails.imageBefore')}}</h6>
                    <img :src="MEDIA_URL+row.imageBefore" class="w-100 max-height-img" alt="">
                  </div>
                  <div class="col-12">
                    <h6 class="almarai-bold pt-2">{{$t('maintenanceDetails.imageAfter')}}</h6>
                    <img :src="MEDIA_URL+row.imageAfter" class="w-100 max-height-img" alt="">
                  </div>
                </div> -->
              </div>

              <div class="col-12 col-lg-6 d-none d-lg-block">
                <h6>{{$t('maintenances.orderStatus')}}</h6>
                <div class="row">
                  <div class="col">
                    <div class="card br-radius-16 position-R">
                      <img src="/assets/images/icons/Artboard.png" class="slogan" alt="">
                      <div class="card-body text-center">

                        <div class="row"  v-if="row.status == 'new'">
                          <div class="col-12">
                            <div>
                              <img src="/assets/images/icons/search-Icon.png" class="search-Icon" alt="">
                            </div>
                            <div class="technician-style">
                              <span>{{$t('maintenances.technician')}}</span>
                              <span class="mx-1">🔍</span>
                            </div>
                            <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                            <div class="confirmed">{{$t('maintenances.area')}}</div>
                          </div>
                        </div>

                        <div class="row" v-if="row.Provider">
                          <div class="col-12">
                            <div class="row" v-if="row.status == 'assigned'">
                              <div class="col">
                                <div>
                                  <img src="/assets/images/icons/moto.png" class="search-Icon" alt="">
                                </div>
                                <div class="technician-style">
                                  <!-- <span>{{$t('maintenances.technician')}}</span> -->
                                  <span>{{$t('maintenanceDetails.theTechnician')}}</span>
                                  <span class="mx-1">🔧</span>
                                </div>
                                <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                                <div class="confirmed">{{$t('maintenances.area')}}</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row" v-if="row.Provider">
                          <div class="col-12">
                            <div class="row" v-if="row.status == 'arrived'">
                              <div class="col">
                                <div>
                                  <img src="/assets/images/icons/worker-yellow.png" alt="">
                                </div>
                                <div class="technician-style">
                                  <span>{{$t('maintenanceDetails.theTechnician')}}</span>
                                  <span class="mx-1">🔧</span>
                                </div>
                                <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                                <div class="confirmed">{{$t('maintenances.area')}}</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row" v-if="row.status == 'done'">
                          <div class="col">
                            <div>
                              <img src="/assets/images/icons/trueIcon.png" class="search-Icon" alt="">
                            </div>
                            <div class="technician-style">
                              <span>{{$t('maintenanceDetails.successfullyResolved')}}</span>
                            </div>
                            <!-- <div class="confirmed">{{$t('maintenances.confirmed')}}</div>
                            <div class="confirmed">{{$t('maintenances.area')}}</div> -->
                          </div>
                        </div>

                        <div class="row" v-if="['client_canceled','provier_canceled'].indexOf(row.status) != -1">
                          <div class="text-center">
                            <img src="/assets/images/icons/Erorr_img.png" class="max-60" alt="">
                          </div>
                          <div class="col pt-3 almarai-bold">
                            {{status[row.status]}}
                          </div>
                        </div>

                        <div class="row" v-if="['deposit_issue','hold','payment_issue','scheduled','under_review','waiting_deposit','waiting_payment'].indexOf(row.status) != -1">
                          <div class="text-center">
                            <img src="/assets/images/icons/wating_img.png" class="max-60" alt="">
                          </div>
                          <div class="col almarai-bold pt-3">
                            {{status[row.status]}}
                          </div>
                        </div>

                        <div class="row pt-3">
                          <div class="col-12">
                            <span :class="(['new', 'assigned', 'arrived', 'done', 'hold', 'scheduled'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['assigned', 'arrived', 'done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['arrived', 'done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                            <span :class="(['done'].indexOf(row.status) != -1)? 'statusLine bg-Orange':'statusLine'"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-5 justify-content-center">
                  <!-- <div class="col-11 col-md-8 content-end text-center" v-if="row.deposit !=0 && row.status == 'waiting_deposit' || row.status == 'deposit_issue'">
                    <div @click.prevent="paymentFN" class="form-control padding-style almarai-bold buttonStyle">{{$t('maintenanceDetails.title_5')}} {{row.deposit}} {{$t('maintenanceDetails.title_7')}} </div>
                  </div> -->
                  <div class="col-11 col-md-8 text-center" v-if="row.finalPayment != 0 && row.status == 'payment_issue' || row.status == 'waiting_payment'">
                    <div @click.prevent="paymentFN" class="form-control btn-black">
                      {{$t('photographyDetails.payOrder')}}  
                    </div>
                  </div>
                  <div class="col-11 col-md-8 text-center mt-3" v-if="row.status !='done' && row.status !='client_canceled' && row.status !='provier_canceled'" @click="poupCanenllOrder"> 
                    <button class="form-control black-button almarai-bold padding-style">{{$t('photographyDetails.cancel_photorequest')}}</button>
                  </div>
                  <!-- <div class="col-11 text-center mt-3" v-if="row.status =='done' && !row.rate" @click.prevent="ratingPoup"> 
                    <div class="form-control black-button almarai-bold padding-style">
                      {{$t('maintenanceDetails.evaluateExperience')}}
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--begin:form success-->
    <div class="row" v-if="step == 2">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div><img src="/assets/images/tick-circle.png" class="width-48" alt=""></div>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col-12 text-center">
            <h4 class="almarai-bold">تم الدفع بنجاح</h4>
          </div>
        </div>
        <!-- <div class="row pt-2">
          <div class="col text-center">
            <span class="p-content"></span>
          </div>
        </div> -->

        <div class="row py-4 justify-content-center">
          <div class="col-12 col-md-5">
            <router-link to="/">
              <button class="btn-black form-control">{{$t('formSuccess.title_4')}}</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--end:form success-->

    <!--begin: modal cancelOrder-->
    <div class="modal bg-color-B" tabindex="-1" id="canceled">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('photographyDetails.title_1')}}</h5>
            <button type="button" class="btn-close m-0" @click="closePoup" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="row">
            <div class="col-12">
              <div v-if="hasError" class="text-center">
                <errorAlert :alertMessage="message" :errorNumber="errorNumber" />
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row py-3">
              <div class="col">
                <label class="fonttext-14 almarai-regular gray-color">{{$t('photographyDetails.title_2')}}</label>
                <select name="" id="" class="form-select input-style" v-model="cancelReason">
                  <option value="" selected>{{$t('maintenanceDetails.title_9')}}</option>
                  <option v-for="(val, key) in client" :value="key" :key="key" >{{val}}</option>
                </select>
              </div>
            </div>
            <div class="row" v-if="!row.arriveTime">
              <div class="col text-center" @click="cancelOrder"> 
                <div class="text-center" v-if="LOADING">
                  <loader />
                </div>
                <div v-else class="form-control btn-black">{{$t('photographyDetails.Cancel_Order_Button')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end: modal cancelOrder-->

    <!-- begin:modal-payment -->
    <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="d-flex">
            <button type="button" id="closeModal" class="btn-close p-3" data-bs-dismiss="modal" aria-label="Close"></button>
            <h1 class="modal-title fs-5 pt-2" id="paymentModalLabel">{{$t('wallet.title_12')}}</h1>
          </div>
          <div class="modal-body">
            <label for="" class="text-style">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-11 mouse-hand">
                <div class="form-check input-style position-R">
                  <label for="visa" class="selectPay">
                    <input class="form-check-input check-radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/Frame_41.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_14')}}</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-11 mouse-hand">
                <div class="form-check input-style position-R">
                  <label for="radioDefault1" class="selectPay">
                    <input class="form-check-input check-radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/img-3.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_16')}}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="row pt-5">
              <loader v-if="submitLoading" />
              <div v-else class="col mouse-hand" @click.prevent="photographyPay">
                <div class="buttonStyle padding-style almarai-bold form-control">{{$t('wallet.title_15')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal-payment -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from 'moment';
export default {
  name: "photographyDetails",

  data(){
    return{
      hasError: false,
      message: "",
      errorNumber: "",
      orderID: this.$route.params.id,
      isLoading: true,
      row:{},
      status: {},
      client: {},
      formattedTime: null,
      hours: null,
      minutes: null,
      nowTime: null,
      LOADING: false,
      cancelReason: "",
      currentStage: 'created',
      userLang: 'ar',
      paymentGate: '',
      step: 1,
      submitLoading: false,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },

  methods:{
    photographyRetrieve(){
      this.hasError = false;
      this.$http.get("/api/photos/retrieve/"+this.orderID).then(res => {
        // console.log(res);
        this.row = res.data.row;
        this.status = res.data.orderStatus;
        this.client = res.data.orderCancelClient;
        if(this.row.doneTime){
          this.currentStage = 'done';
        }else if(this.row.arriveTime){
          this.currentStage = 'arrive';
        }else if(this.row.assignTime){
          this.currentStage = 'assign';
        }
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    moment,
    formatDate(){
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime); 
    },
    cancelOrder(){
      this.hasError = false;
      this.LOADING = true;
      this.$http.post("/api/photos/cancel/"+this.orderID,{
        cancelReason : this.cancelReason,
      }).then(res => {
        // console.log(res);
        this.$router.push({path : "/myrequests" });
        this.LOADING = false;
      }).catch(err => {
        // console.log(err);
        this.LOADING = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    photographyPay(){
      this.payError = false;
      this.submitLoading = true;
      this.$http.post("/api/photos/pay",{
      orderId: this.orderID,
      paymentGate: this.paymentGate,
      }).then(res => {
        if( this.paymentGate == 'online' && res.data.paymentUrl ){
          window.location.href= res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            document.getElementById('closeModal').click();
          }
          this.step = 2;
        }
        this.submitLoading = false;
      }).catch(err => {
        // console.log(err);
        this.submitLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.payError = true;
        window.scroll(0,0);
      });
    },

    poupCanenllOrder(){
      document.getElementById("canceled").style.display = "block";
    },

    closePoup(){
      document.getElementById("canceled").style.display = "none";
    },

    paymentFN(){
      document.getElementById('selectPayment').click();
    },
  },
  created(){
    this.photographyRetrieve();
    this.formatDate();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>